import apiClient, { getBenefitsDictionary } from "../../../../../../services/apiClient";


const curDate = new Date();

export const getListOfChildrensInKG = async (kg_id, year)=>{


    const transformData = (data)=>{

        const retAr = [];

        const statReg = {kyivreg: 0, munic: 0, spec_educ: 0};

        data.forEach((ch, idx)=>{

            const { statusMR, relationFamily, spec_educ, tabelNumber, attnd_period, attnd_2m, attnd_3m, lastName, firstName, groupName, groupNumber, _id, groupId, birthCertificateNumber, typeKitchen } = ch;

            const isRegKyiv = statusMR && statusMR.result && statusMR.result == 'true';
            const isMRCard =  relationFamily && relationFamily.reduce((acc,cur)=> acc || ( cur.statusMR && cur.statusMR.result && cur.statusMR.result == 'true'), false);

            const {} = ch;

            const outObj = { 
                idx: idx + 1,
                _id,
                groupId,
                birthCertificateNumber: birthCertificateNumber || '',
                // Той самий формат, що й у TableChildren (`foodType`), потрібен для onActionSelect -> ChildCardModal.
                typeKitchen: typeKitchen == 'diet' ? 'дієтичне' : 'звичайне',
                birth_date: (new Date(ch['birthDate'])).toLocaleDateString('uk'),
                kyivreg: (isRegKyiv && 'Зареєстрований') || 'Відсутня',
                is_card_mr: (isMRCard && 'Є, перевірена') || 'Не має',
                sed: (spec_educ && 'Так, потребує') || 'Ні, немає',
                attnd_mis: !attnd_3m ? 3 : !attnd_2m ? 2 : attnd_period == 0 ? 1 : 0,
                lastName, firstName, tabelNumber,
                groupName: `${groupNumber} ${groupName}`
            };

            if(ch.hasOwnProperty('tempMoved')) outObj['groupName'] = `${ch['groupName']}(Тимчасово переведений до іншого ЗДО)`;
            if(ch.hasOwnProperty('tempMovedTo')) outObj['groupName'] = `${ch['groupName']}(Тимчасово переведений з іншого ЗДО)`;


            if(isRegKyiv) statReg.kyivreg += 1;
            if(isMRCard) statReg.munic += 1;
            if(spec_educ) statReg.spec_educ += 1;


            retAr.push(outObj);

        })

        return ({data: retAr, statistic: statReg});

    }


        
    const url = `kindergartens/${kg_id}/children/main_info_kg?type=only_child&period_start_year=${year}&date_to=${curDate.toISOString()}`;

    try {
      
      const data = await apiClient.get(url);
      
      if (!data.data) {
        throw new Error(data.message || 'Помилка при отриманні переліку дітей в садочку');
      }
      
      return transformData(data.data);

    } catch (error) {
      console.error('Помилка перевірки максимальних одиниць:', error);
      throw error;
    }

}


export const getBenefitsListKG = async (kg_id, year)=>{

    //Кількість дітей, що мають пільги
    //Назва пільги    Кількість дітей

    //Діти, що мають пільги
    //Прізвище Ім'я Дата народження  Група  Пільга в ЗДО   Пільга батьківська оплата


    const createStat = (data)=>{
        const stat = { kg:{}, kitchen:{} };
        data.forEach(ch=>{
            const { benefits, benKitchen } = ch;

            const benefitId = benefits && benefits[0] && benefits[0]['benefitId'] || '';

            if(benefitId && !stat.kg[benefitId])  stat.kg[benefitId] = 0;
            if(benefitId) stat.kg[benefitId] += 1;

            if(benKitchen && benKitchen.name && !stat.kitchen[benKitchen.name]) stat.kitchen[benKitchen.name] = 0;

            if(benKitchen && benKitchen.name) stat.kitchen[benKitchen.name] += 1;
        });

        return stat;
    };

    const url = `benefits_list_kg?id=${kg_id}&period_start_year=${year}&date_to=${curDate.toISOString()}`

    try {
      
      const data = await apiClient.get(url);
      
      if (!data.data) {
        throw new Error(data.message || 'Помилка при отриманні переліку дітей в садочку');
      }
      
      return ({data: data.data, stat: createStat(data.data)});

    } catch (error) {
      console.error('Помилка перевірки максимальних одиниць:', error);
      throw error;
    }



}

export const getTabelKg = async (kg_id) =>{
    const url = `tabel_kg/sum/${kg_id}`;
}


export const getBenefits = async ()=>{
    
  return await getBenefitsDictionary();

}